import { TFunction } from 'i18next';
import React from 'react';

import { useAuth } from '../../app/AuthorizationProvider';
import { getCalculatedHoursMinutes } from '../../utils/date';

interface OverviewInformationProps {
  workDays: number;
  vacationDays: number;
  workHours: number;
  t: TFunction;
  testIdPrefix?: string;
}

export const OverviewInformation: React.FC<OverviewInformationProps> = ({
  workDays = 0,
  vacationDays = 0,
  workHours = 0,
  t,
  testIdPrefix,
}) => {
  const { locale } = useAuth();

  const { hours: hrs, minutes: min } = getCalculatedHoursMinutes(workHours);

  const durationInHoursLabel = (
    <>
      <strong className="overview-information__work-hours-hours-value">{hrs}</strong> {t('time.hrs')}
    </>
  );

  const durationInMinutesLabel = (
    <>
      <strong className="overview-information__work-hours-minutes-value">{min}</strong> {t('time.min')}
    </>
  );

  return (
    <div className="overview-information" data-test-id={testIdPrefix && `${testIdPrefix}:overview-information`}>
      <div className="overview-information__wrapper-days">
        <span className="overview-information__work-days">
          {t('schedule.mySchedule.workDays')}:{' '}
          <strong className="overview-information__work-days-value">{workDays.toLocaleString(locale)}</strong>
        </span>
        <span className="overview-information__vacation-days">
          {t('schedule.mySchedule.vacationDays')}:{' '}
          <strong className="overview-information__vacation-days-value">{vacationDays.toLocaleString(locale)}</strong>
        </span>
      </div>
      <div className="overview-information__work-hours">
        {t('schedule.mySchedule.workTotal')}:{' '}
        {hrs && min ? (
          <>
            {durationInHoursLabel} {durationInMinutesLabel}
          </>
        ) : min ? (
          durationInMinutesLabel
        ) : (
          durationInHoursLabel
        )}
        .
      </div>
    </div>
  );
};
